import { I2C } from "../../PCBHelper/constants";

export const VDD = 'vdds', CLOCK = 'clocks';
export const I2C_DEFAULT_SPEC = {
  [VDD]: [{
    value: "1.8",
    label: "1.8V",
    defaultConfig: {

      "vdd": "1.8",
      "vHigh": {
        "min": "70%",
        "max": "%"
      },
      "vLow": {
        "min": "0",
        "max": "30%"
      }
      /* "vdd": "1.8",
      "vHigh": {
        "min": "1.7",
        "max": "2"
      },
      "vLow": {
        "min": "-300m",
        "max": "200m"
      } */
    }
  }],
  [CLOCK]: [
    {
      value: "100K",
      label: "100KHz",
      timing: "1000n",
      defaultConfig: {
        "clock": "100K",
        "rising": {
          "min": "n",
          "max": "1000n"
        },
        "falling": {
          "min": "n",
          "max": "300n"
        },
        "setup": {
          "min": "250n",
          "max": "n"
        },
        "hold": {
          "min": "300n",
          "max": "3450n"
        },
        "valid": {
          "min": "n",
          "max": "3450n"
        }
      }
    },
    {
      value: "400K",
      label: "400KHz",
      defaultConfig: {
        "clock": "400K",
        "rising": {
          "min": "20n",
          "max": "300n"
        },
        "falling": {
          "min": "10n",
          "max": "300n"
        },
        "setup": {
          "min": "100n",
          "max": "n"
        },
        "hold": {
          "min": "300n",
          "max": "900n"
        },
        "valid": {
          "min": "n",
          "max": "900n"
        }
      }
    },
    {
      value: "1M",
      label: "1MHz",
      defaultConfig: {
        "clock": "1M",
        "rising": {
          "min": "n",
          "max": "120n"
        },
        "falling": {
          "min": "10n",
          "max": "120n"
        },
        "setup": {
          "min": "50n",
          "max": "n"
        },
        "hold": {
          "min": "0n",
          "max": "n"
        },
        "valid": {
          "min": "n",
          "max": "4500n"
        }
      }
    },
    {
      value: "3.4M",
      label: "3.4MHz",
      defaultConfig: {
        "clock": "3.4M",
        "rising": {
          "min": "10n",
          "max": "80n"
        },
        "falling": {
          "min": "10n",
          "max": "80n"
        },
        "setup": {
          "min": "10n",
          "max": "n"
        },
        "hold": {
          "min": "0n",
          "max": "250n"
        },
        "valid": {
          "min": "n",
          "max": "n"
        }
      }
    },
    {
      value: "5M",
      label: "5MHz",
      defaultConfig: {
        "clock": "5M",
        "rising": {
          "min": "25n",
          "max": "50n"
        },
        "falling": {
          "min": "25n",
          "max": "50n"
        },
        "setup": {
          "min": "30n",
          "max": "n"
        },
        "hold": {
          "min": "10n",
          "max": "n"
        },
        "valid": {
          "min": "10n",
          "max": "n"
        }
      }
    },
  ]
},
  GENERIC_DEFAULT_SPEC = {
    [VDD]: [{
      value: "1.8",
      label: "1.8V",
      defaultConfig: {
        "vdd": "1.8",
        "vHigh": {
          "min": "70%",
          "max": "%"
        },
        "vLow": {
          "min": "0",
          "max": "30%"
        }
      }
    }],
    [CLOCK]: [
      {
        value: "1M",
        label: "1MHz",
        defaultConfig: {
          "clock": "1M",
          "rising": {
            "min": "n",
            "max": "n"
          },
          "falling": {
            "min": "n",
            "max": "n"
          },
          "setup": {
            "min": "n",
            "max": "n"
          },
          "hold": {
            "min": "n",
            "max": "n"
          }
        }
      }
    ]
  };
export const defaultSpecConfig = {
  "gpioType": "I2C",
  [VDD]: JSON.parse(JSON.stringify([I2C_DEFAULT_SPEC[VDD][0].defaultConfig])),
  [CLOCK]: JSON.parse(JSON.stringify([I2C_DEFAULT_SPEC[CLOCK].find(item => item.value === "1M").defaultConfig])),
}


function getSelectValueOptions(gpioType) {
  if (gpioType === I2C) {
    return I2C_DEFAULT_SPEC
  }
  return GENERIC_DEFAULT_SPEC;
}

function getSpecItemTitle(type) {
  if (type === VDD) {
    return "VDD";
  }
  if (type === CLOCK) {
    return "Clock";
  }
  return type;
}

function getSpecItemKey(type) {
  if (type === VDD) {
    return "vdd";
  }
  if (type === CLOCK) {
    return "clock";
  }
  return type;
}

export {
  getSelectValueOptions,
  getSpecItemTitle,
  getSpecItemKey
}